import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery, useTheme } from "@mui/material";

import CartListMobileRow from "./CartListMobileRow";
import CartListDesktopRow from "./CartListDesktopRow";
import { addInsideCartPage, clear, removeInsideCartPage, updateCartOnServer, updateCartPdOnServer } from "../../../../../Store/Slices/CartSlice/cartSlice";


export default function CartListRow({ item, clearFullyCart }) {
  const isMobile = useMediaQuery("(max-width : 600px)");
  const theme = useTheme();
  const dispatch = useDispatch();
  // console.log("item", item);
  const { token } = useSelector((state) => state.userSlice);
  const { list } = useSelector((state) => state.cartSlice);

  // ✅ find the current quantity for this item in Redux
  const currentItem = list?.find((e) => e.variant_code === item.variant_code);
  const Qty = currentItem?.quantity || 0;
  // console.log(item);
  /** ---------------- handlers ---------------- */
  const handleAdd = () => {
    if (token) {
      dispatch(addInsideCartPage(item)); // optimistic local update
      dispatch(
        updateCartOnServer({
          product_code: item.code,
          variant_code: item.variant_code,
          qty: Qty + 1, // use latest quantity
        })
      );
    } else {
      dispatch(addInsideCartPage(item));
    }
  };

  const handleRemove = () => {
    if (token) {
      dispatch(removeInsideCartPage(item));
      dispatch(
        updateCartOnServer({
          product_code: item.code,
          variant_code: item.variant_code,
          qty: Math.max(Qty - 1, 0),
        })
      );
    } else {
      dispatch(removeInsideCartPage(item));
    }
  };

  const handleClear = () => {
    if (token) {
      dispatch(
        clear({
          code: item.code,
          variant_code: item.variant_code,
        })
      );
      dispatch(
        updateCartOnServer({
          product_code: item.code,
          variant_code: item.variant_code,
          qty: -Qty, // clear all
          sum: true,
        })
      );
      // clearFullyCart(item.code, item.variant_code);
    } else {
      dispatch(
        clear({
          code: item.code,
          variant_code: item.variant_code,
        })
      );
    }
  };
  // console.log(item)
  /** ---------------- render ---------------- */
  if (isMobile) {
    return (
      <CartListMobileRow
        img={item?.image}
        prCode={item?.code}
        vrCode={item?.variant_code}
        title={item?.name}
        price={item?.price}
        max={+item?.order_limit || +item?.limit}
        qty={Qty}
        weight={item?.more?.weight || item?.weight}
        addPrToCart={handleAdd}
        removePrToCart={handleRemove}
        clearPrToCart={handleClear}
        clearFullyCart={clearFullyCart}
      />
    );
  }

  return (
    <CartListDesktopRow
      img={item?.image}
      prCode={item?.code}
      vrCode={item?.variant_code}
      title={item?.name}
      max={+item?.order_limit || +item?.limit}
      price={item?.price}
      qty={Qty}
      weight={item?.more?.weight || item?.weight}
      addPrToCart={handleAdd}
      removePrToCart={handleRemove}
      clearPrToCart={handleClear}
      clearFullyCart={clearFullyCart}
    />
  );
}
